import { NamedError } from '../../utils/Errors';

export class RealTimeTranscriptionConnectionError extends NamedError<RealTimeTranscriptionConnectionErrors> {}

export enum RealTimeTranscriptionConnectionErrors {
    MicrophonePermissionError = 'MicrophonePermissionError', // User did not grant microphone permissions
    MicrophoneNotFoundError = 'MicrophoneNotFoundError', // Microphone could not be found
    MicrophoneNotReadableError = 'MicrophoneNotReadableError' // Unable to read audio streams from microphone
}

export function isUserMicrophoneError(error: any): boolean {
    return (error instanceof RealTimeTranscriptionConnectionError
        && (error.name == RealTimeTranscriptionConnectionErrors.MicrophonePermissionError
            || error.name == RealTimeTranscriptionConnectionErrors.MicrophoneNotFoundError
            || error.name == RealTimeTranscriptionConnectionErrors.MicrophoneNotReadableError))
}